import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CfcService } from '../cfc.service';

@Component({
  selector: 'sispac-visualizar-termo-aditivo-cfc',
  templateUrl: './visualizar-termo-aditivo-cfc.component.html',
  styleUrls: ['./visualizar-termo-aditivo-cfc.component.css']
})
export class VisualizarTermoAditivoCfcComponent implements OnInit {

  public dados;
  constructor(
    private route: ActivatedRoute,
    private cfcService: CfcService,
    private router: Router,
  ){

    this.route.paramMap
      .subscribe(params => {

        if(params.has("idCfcTermoAditivo")){
          this.buscarDados(params.get('idCfcTermoAditivo'));
        }

      });
  }

  ngOnInit() {
  }

  buscarDados(idCfcTermoAditivo){

    this.cfcService.getTermoAditivo(idCfcTermoAditivo).subscribe(
      response => {
        this.dados = response;
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/components/cfc/visualizar-termo-aditivo-cfc/visualizar-termo-aditivo-cfc.component.ts